// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isEmpty } from 'lodash/fp';

// Components
import ActivityIndicator from './ActivityIndicator';
import { individualTaskItemActivitySelector } from './selectors/boardActivitySelector';

const createMapStateToProps = () =>
    createStructuredSelector({
        taskItemActivity: individualTaskItemActivitySelector(),
    });

/**
 * Shows an in-board activity badge on a V2 task-list node when it has unseen
 * assignment/reaction/label activity, mirroring `CommentActivityIndicator` /
 * `ElementActivityIndicator` for the task's own stable id.
 */
const TaskItemActivityIndicator = (props) => {
    const { taskItemActivity, taskId, isSelected } = props;

    if (isEmpty(taskItemActivity)) return null;

    return <ActivityIndicator elementId={taskId} toggleVal={isSelected} elementActivity={taskItemActivity} />;
};

TaskItemActivityIndicator.propTypes = {
    taskId: PropTypes.string,
    taskItemActivity: PropTypes.object,
    isSelected: PropTypes.bool,
};

export default connect(createMapStateToProps)(TaskItemActivityIndicator);
